import { http } from "../utils/http";

/** Структура компании (backend /v1/org-chart), правка №9. [Claude] 2026-11-02 */
export const getOrgChart = ({ archived = false } = {}) => http.get(`/org-chart${archived ? "?archived=true" : ""}`);
export const getOrgChartLog = () => http.get("/org-chart/log");
export const getEmployeeOrgUnits = (employeeId) => http.get(`/org-chart/employees/${encodeURIComponent(employeeId)}/units`);

export const createOrgUnit = (data) => http.post("/org-chart/units", data);
export const updateOrgUnit = (id, data) => http.patch(`/org-chart/units/${id}`, data);
export const reorderOrgUnits = (parentId, ids) => http.post("/org-chart/units/reorder", { parent_id: parentId, ids });
export const archiveOrgUnit = (id) => http.post(`/org-chart/units/${id}/archive`, {});
/** Удалить совсем: подотделы и люди переходят в вышестоящее (доработка 03.11.2026, Чат 4). [Claude] */
export const deleteOrgUnit = (id) => http.del(`/org-chart/units/${id}`);
// Дополнительное подчинение и расположение карточек (доработка 03.11.2026, Чат 4). [Claude]
export const addOrgLink = (unitId, parentId) => http.post(`/org-chart/units/${unitId}/links`, { parent_id: parentId });
export const removeOrgLink = (linkId) => http.del(`/org-chart/links/${linkId}`);
export const setOrgUnitPosition = (unitId, { mode, dx, dy }) => http.put(`/org-chart/units/${unitId}/position`, { mode, dx, dy });
export const resetOrgPositions = (mode) => http.post("/org-chart/positions/reset", { mode });
export const restoreOrgUnit = (id) => http.post(`/org-chart/units/${id}/restore`, {});
export const importOrgDepartments = () => http.post("/org-chart/import-departments", {});

export const addOrgMember = (unitId, data) => http.post(`/org-chart/units/${unitId}/members`, data);
export const updateOrgMember = (id, data) => http.patch(`/org-chart/members/${id}`, data);
export const removeOrgMember = (id) => http.del(`/org-chart/members/${id}`);
